var map = {
	"./ar/about-us": [
		98913,
		8913
	],
	"./ar/about-us.json": [
		98913,
		8913
	],
	"./ar/account-statement": [
		95469,
		5469
	],
	"./ar/account-statement.json": [
		95469,
		5469
	],
	"./ar/call-request": [
		65141,
		5141
	],
	"./ar/call-request.json": [
		65141,
		5141
	],
	"./ar/change-password": [
		54463,
		4463
	],
	"./ar/change-password.json": [
		54463,
		4463
	],
	"./ar/common-locale": [
		93638,
		3638
	],
	"./ar/common-locale.json": [
		93638,
		3638
	],
	"./ar/company-register": [
		70575,
		575
	],
	"./ar/company-register.json": [
		70575,
		575
	],
	"./ar/conflict-policy": [
		52900,
		2900
	],
	"./ar/conflict-policy.json": [
		52900,
		2900
	],
	"./ar/corporate-kyc": [
		80272,
		272
	],
	"./ar/corporate-kyc.json": [
		80272,
		272
	],
	"./ar/delete-account": [
		96755,
		6755
	],
	"./ar/delete-account.json": [
		96755,
		6755
	],
	"./ar/deposit": [
		93337,
		3337
	],
	"./ar/deposit.json": [
		93337,
		3337
	],
	"./ar/directors": [
		55220,
		5220
	],
	"./ar/directors.json": [
		55220,
		5220
	],
	"./ar/ehsan": [
		70695,
		695
	],
	"./ar/ehsan.json": [
		70695,
		695
	],
	"./ar/error-locale": [
		82421,
		2421
	],
	"./ar/error-locale.json": [
		82421,
		2421
	],
	"./ar/faq": [
		86338,
		6338
	],
	"./ar/faq.json": [
		86338,
		6338
	],
	"./ar/forgot": [
		70571,
		571
	],
	"./ar/forgot.json": [
		70571,
		571
	],
	"./ar/fund-details": [
		32815,
		2815
	],
	"./ar/fund-details.json": [
		32815,
		2815
	],
	"./ar/home": [
		50609,
		609
	],
	"./ar/home.json": [
		50609,
		609
	],
	"./ar/invest": [
		8768,
		8768
	],
	"./ar/invest.json": [
		8768,
		8768
	],
	"./ar/investment-calculator": [
		29064,
		9064
	],
	"./ar/investment-calculator.json": [
		29064,
		9064
	],
	"./ar/investor-account": [
		50202,
		202
	],
	"./ar/investor-account.json": [
		50202,
		202
	],
	"./ar/labels": [
		26964,
		6964
	],
	"./ar/labels.json": [
		26964,
		6964
	],
	"./ar/landing": [
		84931,
		4931
	],
	"./ar/landing.json": [
		84931,
		4931
	],
	"./ar/login": [
		44927,
		4927
	],
	"./ar/login.json": [
		44927,
		4927
	],
	"./ar/maintenance": [
		42664,
		2664
	],
	"./ar/maintenance.json": [
		42664,
		2664
	],
	"./ar/membership": [
		36745,
		6745
	],
	"./ar/membership.json": [
		36745,
		6745
	],
	"./ar/my-account": [
		85536,
		5536
	],
	"./ar/my-account.json": [
		85536,
		5536
	],
	"./ar/my-investment": [
		44589,
		4589
	],
	"./ar/my-investment-fund": [
		97172,
		7172
	],
	"./ar/my-investment-fund.json": [
		97172,
		7172
	],
	"./ar/my-investment.json": [
		44589,
		4589
	],
	"./ar/my-profile": [
		50842,
		842
	],
	"./ar/my-profile.json": [
		50842,
		842
	],
	"./ar/my-wallet": [
		98982,
		8982
	],
	"./ar/my-wallet.json": [
		98982,
		8982
	],
	"./ar/opening-agreement": [
		64738,
		4738
	],
	"./ar/opening-agreement.json": [
		64738,
		4738
	],
	"./ar/otp": [
		87507,
		7507
	],
	"./ar/otp.json": [
		87507,
		7507
	],
	"./ar/placeholders": [
		17048,
		7048
	],
	"./ar/placeholders.json": [
		17048,
		7048
	],
	"./ar/prev-investment": [
		80684,
		1629
	],
	"./ar/prev-investment.json": [
		80684,
		1629
	],
	"./ar/privacy-policy": [
		57215,
		7215
	],
	"./ar/privacy-policy.json": [
		57215,
		7215
	],
	"./ar/register": [
		11448,
		1448
	],
	"./ar/register.json": [
		11448,
		1448
	],
	"./ar/reset": [
		94091,
		4091
	],
	"./ar/reset.json": [
		94091,
		4091
	],
	"./ar/sharia-committee": [
		2602,
		2602
	],
	"./ar/sharia-committee.json": [
		2602,
		2602
	],
	"./ar/submit-opportunities": [
		1798,
		1798
	],
	"./ar/submit-opportunities.json": [
		1798,
		1798
	],
	"./ar/withdraw": [
		54702,
		4702
	],
	"./ar/withdraw.json": [
		54702,
		4702
	],
	"./ar/zakat-calculator": [
		71197,
		1197
	],
	"./ar/zakat-calculator.json": [
		71197,
		1197
	],
	"./en/about-us": [
		76187,
		6187
	],
	"./en/about-us.json": [
		76187,
		6187
	],
	"./en/account-statement": [
		76256,
		6256
	],
	"./en/account-statement.json": [
		76256,
		6256
	],
	"./en/call-request": [
		26457,
		6457
	],
	"./en/call-request.json": [
		26457,
		6457
	],
	"./en/change-password": [
		90006,
		72
	],
	"./en/change-password.json": [
		90006,
		72
	],
	"./en/common-locale": [
		55329,
		5329
	],
	"./en/common-locale.json": [
		55329,
		5329
	],
	"./en/company-register": [
		13517,
		3517
	],
	"./en/company-register.json": [
		13517,
		3517
	],
	"./en/conflict-policy": [
		25423,
		5423
	],
	"./en/conflict-policy.json": [
		25423,
		5423
	],
	"./en/corporate-kyc": [
		84905,
		4905
	],
	"./en/corporate-kyc.json": [
		84905,
		4905
	],
	"./en/delete-account": [
		82199,
		2199
	],
	"./en/delete-account.json": [
		82199,
		2199
	],
	"./en/deposit": [
		1515,
		1515
	],
	"./en/deposit.json": [
		1515,
		1515
	],
	"./en/directors": [
		97885,
		7885
	],
	"./en/directors.json": [
		97885,
		7885
	],
	"./en/ehsan": [
		8590,
		8590
	],
	"./en/ehsan.json": [
		8590,
		8590
	],
	"./en/error-locale": [
		35882,
		5882
	],
	"./en/error-locale.json": [
		35882,
		5882
	],
	"./en/faq": [
		84387,
		4387
	],
	"./en/faq.json": [
		84387,
		4387
	],
	"./en/forgot": [
		42644,
		2644
	],
	"./en/forgot.json": [
		42644,
		2644
	],
	"./en/fund-details": [
		52816,
		2816
	],
	"./en/fund-details.json": [
		52816,
		2816
	],
	"./en/home": [
		12482,
		2482
	],
	"./en/home.json": [
		12482,
		2482
	],
	"./en/invest": [
		89166,
		9166
	],
	"./en/invest.json": [
		89166,
		9166
	],
	"./en/investment-calculator": [
		81552,
		1552
	],
	"./en/investment-calculator.json": [
		81552,
		1552
	],
	"./en/investor-account": [
		68800,
		8800
	],
	"./en/investor-account.json": [
		68800,
		8800
	],
	"./en/labels": [
		53148,
		3148
	],
	"./en/labels.json": [
		53148,
		3148
	],
	"./en/landing": [
		39942,
		9942
	],
	"./en/landing.json": [
		39942,
		9942
	],
	"./en/login": [
		16318,
		6318
	],
	"./en/login.json": [
		16318,
		6318
	],
	"./en/maintenance": [
		10897,
		897
	],
	"./en/maintenance.json": [
		10897,
		897
	],
	"./en/membership": [
		54737,
		4737
	],
	"./en/membership.json": [
		54737,
		4737
	],
	"./en/my-account": [
		63774,
		3702
	],
	"./en/my-account.json": [
		63774,
		3702
	],
	"./en/my-investment": [
		78435,
		8435
	],
	"./en/my-investment-fund": [
		87104,
		7353
	],
	"./en/my-investment-fund.json": [
		87104,
		7353
	],
	"./en/my-investment.json": [
		78435,
		8435
	],
	"./en/my-profile": [
		44988,
		4988
	],
	"./en/my-profile.json": [
		44988,
		4988
	],
	"./en/my-wallet": [
		8907,
		8907
	],
	"./en/my-wallet.json": [
		8907,
		8907
	],
	"./en/opening-agreement": [
		9278,
		9278
	],
	"./en/opening-agreement.json": [
		9278,
		9278
	],
	"./en/otp": [
		4504,
		4504
	],
	"./en/otp.json": [
		4504,
		4504
	],
	"./en/placeholders": [
		38167,
		8167
	],
	"./en/placeholders.json": [
		38167,
		8167
	],
	"./en/prev-investment": [
		77339,
		9034
	],
	"./en/prev-investment.json": [
		77339,
		9034
	],
	"./en/privacy-policy": [
		23527,
		3527
	],
	"./en/privacy-policy.json": [
		23527,
		3527
	],
	"./en/register": [
		32946,
		2946
	],
	"./en/register.json": [
		32946,
		2946
	],
	"./en/reset": [
		97325,
		7325
	],
	"./en/reset.json": [
		97325,
		7325
	],
	"./en/sharia-committee": [
		81220,
		1220
	],
	"./en/sharia-committee.json": [
		81220,
		1220
	],
	"./en/submit-opportunities": [
		62853,
		2853
	],
	"./en/submit-opportunities.json": [
		62853,
		2853
	],
	"./en/withdraw": [
		1866,
		1866
	],
	"./en/withdraw.json": [
		1866,
		1866
	],
	"./en/zakat-calculator": [
		542,
		542
	],
	"./en/zakat-calculator.json": [
		542,
		542
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;